import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_sprite = _resolveComponent("sprite")

  return (_openBlock(), _createBlock(_component_sprite, { picture: _ctx.crossVariant }, null, 8 /* PROPS */, ["picture"]))
}